// frontend/src/services/praticheAutoOnline.ts
import axios from 'axios';
import { getAuthHeader } from './otpAuthService';

const REST_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export interface PaolSede {
  key: string;
  label: string;
  isPrincipal: boolean;
}

export const getPaolSedi = async (): Promise<{ enabled: boolean; sedi: PaolSede[] }> => {
  const res = await axios.get(`${REST_BASE}/praticheautoonline/sedi`, {
    headers: getAuthHeader() as any
  });
  return { enabled: !!res.data.enabled, sedi: res.data.sedi || [] };
};

export interface PaolSso {
  token: string;
  method: 'GET' | 'POST';
  ssoUrl: string;
  redirectUrl: string;
}

export const getPaolSso = async (sedeKey: string): Promise<PaolSso> => {
  const res = await axios.post(
    `${REST_BASE}/praticheautoonline/sso-token`,
    { sede: sedeKey },
    { headers: getAuthHeader() as any }
  );
  return {
    token: res.data.token,
    method: res.data.method === 'GET' ? 'GET' : 'POST',
    ssoUrl: res.data.ssoUrl,
    redirectUrl: res.data.redirectUrl
  };
};

/**
 * Consegna il token al portale Pratiche Auto Online.
 * GET: navigazione all'URL firmato. POST: modulo auto-inviante (il token viaggia
 * nel corpo, non nell'URL). Usata dalla card dell'area riservata e dalla pagina
 * /area-riservata/facile/accedi aperta dall'app.
 */
export const apriPortalePaol = (sso: PaolSso): void => {
  if (sso.method === 'GET') {
    window.location.href = sso.redirectUrl;
    return;
  }
  if (!sso.ssoUrl) throw new Error('Endpoint SSO non configurato');
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = sso.ssoUrl;
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'token';
  input.value = sso.token;
  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
};
